var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view',{ref:"UmFold",staticClass:"um-upload-fold",style:(_vm.style)},[_c('view',{staticClass:"um-upload-fold-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }